window.copyTextToClipboard = function (text, input, result) {
  input.val(text);
  input.focus();
  input.select();

  var successful = false;
  try {
    successful = document.execCommand('copy');
  } catch (err) {
  }
  result.html(successful ? 'Copiado com sucesso! <span class="fas fa-check text-success"></span>' : '<span class="text-danger fas fa-exclamation-triangle"></span> Será necessário selecionar o texto acima e utilizar a função de copiar.');
};
